module.exports = __webpack_public_path__ + "img/Bicolor chromis.ae6efc5c.png";